import { DoorConfiguration as contex } from '../DoorConfiguration';
import * as helper from './Shared';
import store from '@/store/index';
import '../types';
import { Characteristic, ValueDefinition } from '../types';
import { DefaultDictionary } from 'typescript-collections';

// KTU_MM_TUEROBERFL_BS
export const getTurOberflacheDekorBSLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    // const doorLeafHeight: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    // const doorLeafWidth: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    const CustTurOberflacheDekorBS = helper.GetDependencyValueCode('CUST_MM_TUEROBERFL_BS', contex.DoorLeafSurface);
    if (CustTurOberflacheDekorBS === '1' ) {
        lltNumber = 'LLT120073';
    }
    else if (CustTurOberflacheDekorBS === '2' ) {
        lltNumber = 'LLT120075';
    }
    else if (CustTurOberflacheDekorBS === '3' ) {
        lltNumber = 'LLT120062';
    }
    else if (CustTurOberflacheDekorBS === '4' ) {
        lltNumber = 'LLT120064';
    }
    else if (CustTurOberflacheDekorBS === '5' ) {
        lltNumber = 'LLT120066';
    }
    else if (CustTurOberflacheDekorBS === '6' ) {
        lltNumber = 'LLT120065';
    }
    else if (CustTurOberflacheDekorBS === '7' ) {
        lltNumber = 'LLT120063';
    }
    else if (CustTurOberflacheDekorBS === '8' ) {
        lltNumber = 'LLT120068';
    }
    else if (CustTurOberflacheDekorBS === '9' ) {
        lltNumber = 'LLT120067';
    }
    else if (CustTurOberflacheDekorBS === '10' ) {
        lltNumber = 'LLT120060';
    }
    // if (CustTurOberflacheDekorBS === '1' ) {
    //     if (doorLeafHeight > 2140 && doorLeafWidth > 1060) {
    //         lltNumber = 'LLT120072';
    //     } else {
    //         lltNumber = 'LLT120073'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorBS === '2') {
    //     lltNumber = 'LLT120060';
    // } else if (CustTurOberflacheDekorBS === '3') {
    //      if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120033';
    //      } else {
    //         lltNumber = 'LLT120062'; // Standart
    //      }
    // } else if (CustTurOberflacheDekorBS === '4') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120063';
    //     } else {
    //         lltNumber = 'LLT120041'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorBS === '5') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120034';
    //     } else {
    //         lltNumber = 'LLT120064'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorBS === '6') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120040';
    //     } else {
    //         lltNumber = 'LLT120065'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorBS === '7') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120037';
    //     } else {
    //         lltNumber = 'LLT120066'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorBS === '8') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120051';
    //     } else {
    //         lltNumber = 'LLT120067'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorBS === '9') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120045';
    //     } else {
    //         lltNumber = 'LLT120068'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorBS === '10') {
    //     if (doorLeafHeight > 2140 && doorLeafWidth > 1060) {
    //         lltNumber = 'LLT120074';
    //     } else {
    //         lltNumber = 'LLT120075'; // Standart
    //     }
    // }

    const TurOberflacheDekorBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_TUEROBERFL_BS')[0];
    const TurOberflacheDekorBSValue: ValueDefinition = TurOberflacheDekorBSCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return TurOberflacheDekorBSValue;
};

// KTU_MM_TUEROBERFL_GBS
export const getTurOberflacheDekorGBSLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    // const doorLeafHeight: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    // const doorLeafWidth: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    const CustTurOberflacheDekorGBS = helper.GetDependencyValueCode('CUST_MM_TUEROBERFL_GBS', contex.DoorLeafSurface);
    if (CustTurOberflacheDekorGBS === '1' ) {
        lltNumber = 'LLT120073';
    }
    else if (CustTurOberflacheDekorGBS === '2' ) {
        lltNumber = 'LLT120075';
    }
    else if (CustTurOberflacheDekorGBS === '3' ) {
        lltNumber = 'LLT120062';
    }
    else if (CustTurOberflacheDekorGBS === '4' ) {
        lltNumber = 'LLT120064';
    }
    else if (CustTurOberflacheDekorGBS === '5' ) {
        lltNumber = 'LLT120066';
    }
    else if (CustTurOberflacheDekorGBS === '6' ) {
        lltNumber = 'LLT120065';
    }
    else if (CustTurOberflacheDekorGBS === '7' ) {
        lltNumber = 'LLT120063';
    }
    else if (CustTurOberflacheDekorGBS === '8' ) {
        lltNumber = 'LLT120068';
    }
    else if (CustTurOberflacheDekorGBS === '9' ) {
        lltNumber = 'LLT120067';
    }
    else if (CustTurOberflacheDekorGBS === '10' ) {
        lltNumber = 'LLT120060';
    }

    // lltNumber = CustTurOberflacheDekorGBS;
    // if (CustTurOberflacheDekorGBS === '1' ) {
    //     if (doorLeafHeight > 2140 && doorLeafWidth > 1060) {
    //         lltNumber = 'LLT120072';
    //     } else {
    //         lltNumber = 'LLT120073'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorGBS === '2') {
    //     lltNumber = 'LLT120060';
    // } else if (CustTurOberflacheDekorGBS === '3') {
    //      if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120033';
    //      } else {
    //         lltNumber = 'LLT120062'; // Standart
    //      }
    // } else if (CustTurOberflacheDekorGBS === '4') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120063';
    //     } else {
    //         lltNumber = 'LLT120041'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorGBS === '5') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120034';
    //     } else {
    //         lltNumber = 'LLT120064'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorGBS === '6') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120040';
    //     } else {
    //         lltNumber = 'LLT120065'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorGBS === '7') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120037';
    //     } else {
    //         lltNumber = 'LLT120066'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorGBS === '8') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120051';
    //     } else {
    //         lltNumber = 'LLT120067'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorGBS === '9') {
    //     if (doorLeafHeight > 2150 && doorLeafWidth > 1020) {
    //         lltNumber = 'LLT120045';
    //     } else {
    //         lltNumber = 'LLT120068'; // Standart
    //     }
    // } else if (CustTurOberflacheDekorGBS === '10') {
    //     if (doorLeafHeight > 2140 && doorLeafWidth > 1060) {
    //         lltNumber = 'LLT120074';
    //     } else {
    //         lltNumber = 'LLT120075'; // Standart
    //     }
    // }

    const TurOberflacheDekorBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_TUEROBERFL_GBS')[0];
    const TurOberflacheDekorBSValue: ValueDefinition = TurOberflacheDekorBSCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return TurOberflacheDekorBSValue;
};

//KTU_MM_DICHTUNG
export const getNormalDichtungValue = () : any[] => {
    var rhDichtung =  helper.GetDependencyValueCode('CUST_MM_RH_DICHTUNG', contex.Functions); //KTU_MM_RH_DICHTUNG 
    var customDZDichtung = helper.GetDependencyValueCode('CUST_MM_Z_DICHTUNG', contex.DoorLeafSurface);
    var Doorwing  = helper.GetDependencyValueCode('KTU_MM_KOMBI_ST_OL', contex.ModelSelection);
    var HasTopPanel =  helper.HasTopPanel();
    var IsTwoWingDoor  = Doorwing.includes('D2');

    var resultDichtung : any = null;
    var resultRhDichtung : any = null;
    if(rhDichtung === 'JA')
    {
        if(customDZDichtung !== 'WEISS')
        {
            resultDichtung = 'LLT210007';
            resultRhDichtung = 'JA'
        }else {
            resultDichtung = 'LLT210006';
            resultRhDichtung = 'JA'
        }
    }else if(IsTwoWingDoor)
    {
        if(customDZDichtung !== 'WEISS')
        {
            resultDichtung = 'LLT210007';
            resultRhDichtung = 'JA'
        }else {
            resultDichtung = 'LLT210006';
            resultRhDichtung = 'JA'
        }
    }else if(HasTopPanel)
    {
        if(customDZDichtung !== 'WEISS')
        {
            resultDichtung = 'LLT210007';
            resultRhDichtung = 'JA'
        }else {
            resultDichtung = 'LLT210006';
            resultRhDichtung = 'JA'
        }
    }else {
        resultDichtung = '0';
        resultRhDichtung = 'NEIN'
    }

    const DichtungValues  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_DICHTUNG')[0];
    const DichtungValue: ValueDefinition = DichtungValues.values.filter((v: ValueDefinition) => v.value === resultDichtung)[0];

    const RhDichtungValues  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_RH_DICHTUNG')[0];
    const RhDichtungValue: ValueDefinition = RhDichtungValues.values.filter((v: ValueDefinition) => v.value === resultRhDichtung)[0];


    return [DichtungValue,RhDichtungValue]  
};

//KTU_MM_ABSCHLUSSPROFIL_O
export const getAbschlussprofilOberflache = (): ValueDefinition => 
{
    var Futterplate = helper.GetDependencyValueCode('CUST_MM_FUTTERPLATTE', contex.Frame);
    var KTU_MM_ZARGE_OBERFL_GBS = helper.GetDependencyValueCode('KTU_MM_ZARGE_OBERFL_GBS', contex.DoorLeafSurface);
    var KTU_MM_ABSCHLUSSPROFIL_S = helper.GetDependencyValueCode('KTU_MM_ABSCHLUSSPROFIL_S', contex.Frame);
    var resultLLT = '';

    if(Futterplate === 'JA' && KTU_MM_ZARGE_OBERFL_GBS === 'LLT130010')
    {
        resultLLT = 'KEINE';
    }else if(Futterplate === 'JA' && KTU_MM_ZARGE_OBERFL_GBS !== 'LLT130010')
    {
        resultLLT = KTU_MM_ZARGE_OBERFL_GBS;
    }else {
        resultLLT = KTU_MM_ZARGE_OBERFL_GBS;
    }

    if(KTU_MM_ABSCHLUSSPROFIL_S === 'LLT200005')
    {
        resultLLT = KTU_MM_ZARGE_OBERFL_GBS;
    }else 
    {
        resultLLT = 'KEINE';
    }

    const AbschlussprofilOberflache  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_ABSCHLUSSPROFIL_O')[0];
    const AbschlussprofilOberflacheValue: ValueDefinition = AbschlussprofilOberflache.values.filter((v: ValueDefinition) => v.value === resultLLT)[0];

    return AbschlussprofilOberflacheValue;
};

//KTU_MM_ABSCHLUSSWINKEL_O
export const getAbschlusswinkelOberflache = (): ValueDefinition => 
{
    var Futterplate = helper.GetDependencyValueCode('CUST_MM_FUTTERPLATTE', contex.Frame);
    var KTU_MM_ZARGE_OBERFL_GBS = helper.GetDependencyValueCode('KTU_MM_ZARGE_OBERFL_GBS', contex.DoorLeafSurface);
    var KTU_MM_ABSCHLUSSWINKEL = helper.GetDependencyValueCode('KTU_MM_ABSCHLUSSWINKEL', contex.Frame);
    var resultLLT = '';

    if(Futterplate === 'JA' && KTU_MM_ZARGE_OBERFL_GBS === 'LLT130010')
    {
        resultLLT = 'KEINE';
    }else if(Futterplate === 'JA' && KTU_MM_ZARGE_OBERFL_GBS !== 'LLT130010')
    {
        resultLLT = KTU_MM_ZARGE_OBERFL_GBS;
    }else {
        resultLLT = KTU_MM_ZARGE_OBERFL_GBS;
    }

    if(KTU_MM_ABSCHLUSSWINKEL !== 'NEIN')
    {
        resultLLT = KTU_MM_ZARGE_OBERFL_GBS;
    }else {
        resultLLT = 'KEINE';
    }

    const AbschlusswinkelOberflache  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_ABSCHLUSSWINKEL_O')[0];
    const AbschlusswinkelOberflacheValue: ValueDefinition = AbschlusswinkelOberflache.values.filter((v: ValueDefinition) => v.value === resultLLT)[0];

    return AbschlusswinkelOberflacheValue;
};

//KTU_MM_ABSCHLUSSPROFIL_O_SO
export const getAbschlussprofilOberflacheSO = (): ValueDefinition => {
    const KTU_MM_ABSCHLUSSPROFIL_O = helper.GetDependencyValueCode('KTU_MM_ABSCHLUSSPROFIL_O', contex.DoorLeafSurface);
    const KTU_MM_ZARGE_OBERFL_SOND_GBS = helper.GetDependencyValueCode('KTU_MM_ZARGE_OBERFL_SOND_GBS', contex.DoorLeafSurface);
    let result = '';

    if (KTU_MM_ABSCHLUSSPROFIL_O !== 'KEINE')
        result = KTU_MM_ZARGE_OBERFL_SOND_GBS;
    
    let AbschlussprofilOberflache = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_ABSCHLUSSPROFIL_O_SO')[0];
    AbschlussprofilOberflache.values[0].value = result;
    const AbschlussprofilOberflacheValue: ValueDefinition = AbschlussprofilOberflache.values[0];
    
    return AbschlussprofilOberflacheValue;
}

//KTU_MM_ABSCHLUSSWINKEL_O_SO
export const getAbschlusswinkelOberflacheSO = (): ValueDefinition => {
    const KTU_MM_ABSCHLUSSWINKEL_O = helper.GetDependencyValueCode('KTU_MM_ABSCHLUSSWINKEL_O', contex.DoorLeafSurface);
    const KTU_MM_ZARGE_OBERFL_SOND_GBS = helper.GetDependencyValueCode('KTU_MM_ZARGE_OBERFL_SOND_GBS', contex.DoorLeafSurface);
    let result = '';

    if (KTU_MM_ABSCHLUSSWINKEL_O !== 'KEINE')
        result = KTU_MM_ZARGE_OBERFL_SOND_GBS;

    let AbschlusswinkelOberflache = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_ABSCHLUSSWINKEL_O_SO')[0];
    AbschlusswinkelOberflache.values[0].value = result;
    const AbschlusswinkelOberflacheValue: ValueDefinition = AbschlusswinkelOberflache.values[0];

    return AbschlusswinkelOberflacheValue;
}

export const getTurOberflacheLackierungBSLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    // const doorLeafHeight: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    // const doorLeafWidth: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    const CustTurOberflacheLackierungBS = helper.GetDependencyValueCode('CUST_MM_TUEROBERFL_L_BS', contex.DoorLeafSurface);
    if (CustTurOberflacheLackierungBS === '1' ) {
        lltNumber = 'LLT130010';
    }
    else if (CustTurOberflacheLackierungBS === '2' ) {
        lltNumber = 'LLT130001';
    }
    else if (CustTurOberflacheLackierungBS === '3' ) {
        lltNumber = 'LLT130002';
    }
    else if (CustTurOberflacheLackierungBS === '4' ) {
        lltNumber = 'LLT130003';
    }
    else if (CustTurOberflacheLackierungBS === '5' ) {
        lltNumber = 'LLT130004';
    }
    else if (CustTurOberflacheLackierungBS === '6' ) {
        lltNumber = 'LLT130005';
    }
    else if (CustTurOberflacheLackierungBS === '7' ) {
        lltNumber = 'LLT130006';
    }
    else if (CustTurOberflacheLackierungBS === '8' ) {
        lltNumber = 'LLT130007';
    }
    else if (CustTurOberflacheLackierungBS === '9' ) {
        lltNumber = 'LLT130008';
    }
    else if (CustTurOberflacheLackierungBS === '10' ) {
        lltNumber = 'LLT130020';
    }
    else if (CustTurOberflacheLackierungBS === '11' ) {
        lltNumber = 'LLT130009';
    }
    else if (CustTurOberflacheLackierungBS === '12' ) {
        lltNumber = 'LLT130011';
    }

    const TurOberflacheLackierungBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_TUEROBERFL_L_BS')[0];
    const TurOberflacheLackierungBSValue: ValueDefinition = TurOberflacheLackierungBSCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return TurOberflacheLackierungBSValue;
};

export const getTurOberflacheLackierungGBSLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    // const doorLeafHeight: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    // const doorLeafWidth: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    const CustTurOberflacheLackierungGBS = helper.GetDependencyValueCode('CUST_MM_TUEROBERFL_L_GBS', contex.DoorLeafSurface);
    if (CustTurOberflacheLackierungGBS === '1' ) {
        lltNumber = 'LLT130010';
    }
    else if (CustTurOberflacheLackierungGBS === '2' ) {
        lltNumber = 'LLT130001';
    }
    else if (CustTurOberflacheLackierungGBS === '3' ) {
        lltNumber = 'LLT130002';
    }
    else if (CustTurOberflacheLackierungGBS === '4' ) {
        lltNumber = 'LLT130003';
    }
    else if (CustTurOberflacheLackierungGBS === '5' ) {
        lltNumber = 'LLT130004';
    }
    else if (CustTurOberflacheLackierungGBS === '6' ) {
        lltNumber = 'LLT130005';
    }
    else if (CustTurOberflacheLackierungGBS === '7' ) {
        lltNumber = 'LLT130006';
    }
    else if (CustTurOberflacheLackierungGBS === '8' ) {
        lltNumber = 'LLT130007';
    }
    else if (CustTurOberflacheLackierungGBS === '9' ) {
        lltNumber = 'LLT130008';
    }
    else if (CustTurOberflacheLackierungGBS === '10' ) {
        lltNumber = 'LLT130020';
    }
    else if (CustTurOberflacheLackierungGBS === '11' ) {
        lltNumber = 'LLT130009';
    }
    else if (CustTurOberflacheLackierungGBS === '12' ) {
        lltNumber = 'LLT130011';
    }

    const TurOberflacheLackierungGBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_TUEROBERFL_L_GBS')[0];
    const TurOberflacheLackierungGBSValue: ValueDefinition = TurOberflacheLackierungGBSCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return TurOberflacheLackierungGBSValue;
};

export const getTurOberflacheFurnierBSLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    // const doorLeafHeight: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    // const doorLeafWidth: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    const CustTurFurnierLackierungBS = helper.GetDependencyValueCode('CUST_MM_TUEROBERFL_F_BS', contex.DoorLeafSurface);
    if (CustTurFurnierLackierungBS === '1' ) {
        lltNumber = 'LLT110001';
    }
    else if (CustTurFurnierLackierungBS === '2' ) {
        lltNumber = 'LLT110002';
    }
    else if (CustTurFurnierLackierungBS === '3' ) {
        lltNumber = 'LLT110003';
    }
    else if (CustTurFurnierLackierungBS === '4' ) {
        lltNumber = 'LLT110004';
    }
    else if (CustTurFurnierLackierungBS === '5' ) {
        lltNumber = 'LLT110005';
    }
    else if (CustTurFurnierLackierungBS === '6' ) {
        lltNumber = 'LLT110006';
    }
    else if (CustTurFurnierLackierungBS === '7' ) {
        lltNumber = 'LLT110007';
    }
    else if (CustTurFurnierLackierungBS === '8' ) {
        lltNumber = 'LLT110008';
    }
    else if (CustTurFurnierLackierungBS === '9' ) {
        lltNumber = 'LLT110009';
    }
    else if (CustTurFurnierLackierungBS === '10' ) {
        lltNumber = 'LLT110010';
    }
    else if (CustTurFurnierLackierungBS === '11' ) {
        lltNumber = 'LLT110011';
    }
    else if (CustTurFurnierLackierungBS === '12' ) {
        lltNumber = 'LLT110012';
    }
    else if (CustTurFurnierLackierungBS === '13' ) {
        lltNumber = 'LLT110013';
    }
    else if (CustTurFurnierLackierungBS === '14' ) {
        lltNumber = 'LLT110014';
    }
    else if (CustTurFurnierLackierungBS === '15' ) {
        lltNumber = 'LLT110015';
    }
    else if (CustTurFurnierLackierungBS === '16' ) {
        lltNumber = 'LLT110016';
    }
    else if (CustTurFurnierLackierungBS === '17' ) {
        lltNumber = 'LLT110017';
    }
    else if (CustTurFurnierLackierungBS === '18' ) {
        lltNumber = 'LLT110018';
    }
    else if (CustTurFurnierLackierungBS === '19' ) {
        lltNumber = 'LLT110019';
    }
    else if (CustTurFurnierLackierungBS === '20' ) {
        lltNumber = 'LLT110020';
    }
    else if (CustTurFurnierLackierungBS === '21' ) {
        lltNumber = 'LLT110022';
    }
    else if (CustTurFurnierLackierungBS === '22' ) {
        lltNumber = 'LLT110023';
    }

    const TurOberflacheFurnierBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_TUEROBERFL_F_BS')[0];
    const TurOberflacheFurnierBSValue: ValueDefinition = TurOberflacheFurnierBSCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return TurOberflacheFurnierBSValue;
};

export const getTurOberflacheFurnierGBSLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    // const doorLeafHeight: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTHOEHE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    // const doorLeafWidth: number = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE', contex.Measure); // KTU_MM_TUERBLATTBREITE;
    const CustTurFurnierLackierungGBS = helper.GetDependencyValueCode('CUST_MM_TUEROBERFL_F_GBS', contex.DoorLeafSurface);
    if (CustTurFurnierLackierungGBS === '1' ) {
        lltNumber = 'LLT110001';
    }
    else if (CustTurFurnierLackierungGBS === '2' ) {
        lltNumber = 'LLT110002';
    }
    else if (CustTurFurnierLackierungGBS === '3' ) {
        lltNumber = 'LLT110003';
    }
    else if (CustTurFurnierLackierungGBS === '4' ) {
        lltNumber = 'LLT110004';
    }
    else if (CustTurFurnierLackierungGBS === '5' ) {
        lltNumber = 'LLT110005';
    }
    else if (CustTurFurnierLackierungGBS === '6' ) {
        lltNumber = 'LLT110006';
    }
    else if (CustTurFurnierLackierungGBS === '7' ) {
        lltNumber = 'LLT110007';
    }
    else if (CustTurFurnierLackierungGBS === '8' ) {
        lltNumber = 'LLT110008';
    }
    else if (CustTurFurnierLackierungGBS === '9' ) {
        lltNumber = 'LLT110009';
    }
    else if (CustTurFurnierLackierungGBS === '10' ) {
        lltNumber = 'LLT110010';
    }
    else if (CustTurFurnierLackierungGBS === '11' ) {
        lltNumber = 'LLT110011';
    }
    else if (CustTurFurnierLackierungGBS === '12' ) {
        lltNumber = 'LLT110012';
    }
    else if (CustTurFurnierLackierungGBS === '13' ) {
        lltNumber = 'LLT110013';
    }
    else if (CustTurFurnierLackierungGBS === '14' ) {
        lltNumber = 'LLT110014';
    }
    else if (CustTurFurnierLackierungGBS === '15' ) {
        lltNumber = 'LLT110015';
    }
    else if (CustTurFurnierLackierungGBS === '16' ) {
        lltNumber = 'LLT110016';
    }
    else if (CustTurFurnierLackierungGBS === '17' ) {
        lltNumber = 'LLT110017';
    }
    else if (CustTurFurnierLackierungGBS === '18' ) {
        lltNumber = 'LLT110018';
    }
    else if (CustTurFurnierLackierungGBS === '19' ) {
        lltNumber = 'LLT110019';
    }
    else if (CustTurFurnierLackierungGBS === '20' ) {
        lltNumber = 'LLT110020';
    }
    else if (CustTurFurnierLackierungGBS === '21' ) {
        lltNumber = 'LLT110022';
    }
    else if (CustTurFurnierLackierungGBS === '22' ) {
        lltNumber = 'LLT110023';
    }

    const TurOberflacheFurnierGBSCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_TUEROBERFL_F_GBS')[0];
    const TurOberflacheFurnierGBSValue: ValueDefinition = TurOberflacheFurnierGBSCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return TurOberflacheFurnierGBSValue;
};

export const getOberflaecheLLTValue = (): ValueDefinition => {

    let lltNumber: string = '0';
    const getCustOberflaecheValue = helper.GetDependencyValueCode('CUST_MM_STAFFEL_OBERFLAECHE', contex.DoorLeafSurface);
    if (getCustOberflaecheValue === '1' ) {
        lltNumber = 'LLT120062';
    }
    else if (getCustOberflaecheValue === '2' ) {
        lltNumber = 'LLT120063';
    }
    else if (getCustOberflaecheValue === '3' ) {
        lltNumber = 'LLT120064';
    }
    else if (getCustOberflaecheValue === '4' ) {
        lltNumber = 'LLT120065';
    }
    else if (getCustOberflaecheValue === '5' ) {
        lltNumber = 'LLT120066';
    }
    else if (getCustOberflaecheValue === '6' ) {
        lltNumber = 'LLT120067';
    }
    else if (getCustOberflaecheValue === '7' ) {
        lltNumber = 'LLT120068';
    }
    else if (getCustOberflaecheValue === '8' ) {
        lltNumber = 'LLT120069';
    }
    else if (getCustOberflaecheValue === '9' ) {
        lltNumber = 'LLT120070';
    }
    else if (getCustOberflaecheValue === '10' ) {
        lltNumber = 'LLT120071';
    }
    else if (getCustOberflaecheValue === '11' ) {
        lltNumber = 'LLT120073';
    }
    else if (getCustOberflaecheValue === '12' ) {
        lltNumber = 'LLT120075';
    }
    else if (getCustOberflaecheValue === '13' ) {
        lltNumber = 'LLT120060';
    }

    const getOberflacheCharacteristic  = store.state.doorLeafSurfaceModule.model.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_STAFFEL_OBERFLAECHE')[0];
    const resultOfOberflacheValue: ValueDefinition = getOberflacheCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return resultOfOberflacheValue;
};